import ThemeDefault from './default/theme_default'
import ThemeKovanen from './kovanen/theme_kovanen'
import ThemeEspoo from './espoo/theme_espoo'
import ThemeJytaksi from './jytaksi/theme_jytaksi'
import Theme from './ITheme'

export default class Themes {
    public static themes: Theme[] = [
        new ThemeDefault(),
        new ThemeKovanen(),
        new ThemeEspoo(),
        new ThemeJytaksi()
      ];
}
